import { QueryClient } from '@tanstack/react-query'

const queryClient = new QueryClient({
	defaultOptions: {
		mutations: {
			retry: false,
		},
		queries: {
			retry: 3,
			refetchOnReconnect: false,
			refetchOnWindowFocus: false,
			queryFn: () => Promise.reject(),
		},
	},
})

export default queryClient
